import ModalDefault from "../../modal/modal-default";
import {openInNewTab} from "../../../util/util-helpers";
import {hideGlobalModal, hideModal} from "../../../../data/actions/ui";
import {useDispatch, useSelector} from "react-redux";
import OrganizationInfoDialog from "../../modal/modal-global/organization-info-dialog";
import LocationCardDialog from "../../modal/modal-global/global-location-info"
import React from "react";
import Modal from "../../modal";
import {useHistory, useLocation} from "react-router-dom";
import ModalHeader from "../../modal/modal-header";
import MapDialog from "../../modal/modal-global/map-dialog";
import ContactCardDialog from "../../modal/contact-card-dialog";
import GlobalVendorInfoDialog from "../../modal/modal-global/global-vendor-info-dialog";
import Resources from "../../../../data/services/resources";
import TasksFormDialog from "../../forms/task-form";
import ContactGroupCardDialog from "../../modal/contact-group";
import OfficeCardDialog from "../../modal/office-card";
import ChangePasswordDialog from "../../modal/change-password";
import About from "../../modal/about-dialog";
import ModalSupport from "../../modal/modal-support";
import {getGrabTaskResource} from "../../../../data/actions/taskResource";
import LocalStorage from "../../../util/localStorage";
import TaskGrabDialog from "./global-grab-task-dialog";
import KnowledgeBase from "../../slideover/knowledge-base";

export default function GlobalDialogs({translate}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const ui = useSelector(state => state.ui);
    const helpResource = useSelector(state => state.helpResource);
    const history = useHistory();
    return (
        <>
            <OrganizationInfoDialog
                show={ui.modalName === 'ViewCustomerCard'}
                translate={translate}
                organizationID={ui.data?.OrganizationID}
                handleClose={() => dispatch(hideModal("ViewCustomerCard", 0))}
            />

            <Modal
                show={ui.modalName === 'ViewContactCard'}
                widthClass={"max-w-3xl"}
                onClose={() => dispatch(hideModal("ViewContactCard", 0))}
            >
                <ContactCardDialog
                    show={ui.modalName === 'ViewContactCard'}
                    onClose={() => dispatch(hideModal("ViewContactCard", 0))}
                    translate={translate}
                    ContactID={ui?.data?.ContactID}
                    DriverID={ui?.data?.DriverID}
                    minHeight={"425px"}
                    dispatch={dispatch}
                />
            </Modal>

            <ModalDefault
                show={ui.modalName === 'ViewCarrierCard'}
                title={translate("text.carrier_info")}
                widthClass={"max-w-3xl"}
                translate={translate}
                buttonLabel={translate("btn.edit")}
                onButtonClick={() => openInNewTab("/carriers/info/" + ui?.data?.OrganizationID + "/" + ui?.data?.CarrierID)}
                onClose={() => dispatch(hideModal("ViewCarrierCard", 0))}
                closeButtonLabel={translate("btn.close")}
            >
                <GlobalVendorInfoDialog
                    translate={translate}
                    resourcePath={Resources.Carrier}
                    item={ui?.data}
                    id={"CarrierID"}

                />
            </ModalDefault>

            <ModalDefault
                show={ui.modalName === 'ViewVendorCard'}
                title={translate("text.vendor_info")}
                widthClass={"max-w-3xl"}
                translate={translate}
                buttonLabel={translate("btn.edit")}
                onButtonClick={() => openInNewTab("/vendors/info/" + ui?.data?.OrganizationID + "/" + ui?.data?.VendorID)}
                onClose={() => dispatch(hideModal("ViewVendorCard", 0))}
                closeButtonLabel={translate("btn.close")}
            >
                <GlobalVendorInfoDialog
                    translate={translate}
                    resourcePath={Resources.VendorsInfo}
                    item={ui?.data}
                    id={"VendorID"}
                />
            </ModalDefault>

            <Modal
                show={ui?.globalDialogs?.createTaskDialog?.visible && location.pathname !== "/all-tasks"}
                widthClass={"max-w-5xl"}
                translate={translate}
                onClose={() => dispatch(hideGlobalModal("createTaskDialog"))}
            >
                <TasksFormDialog
                    close={() => dispatch(hideGlobalModal("createTaskDialog"))}
                    TaskID={ui?.globalDialogs?.createTaskDialog?.data?.TaskID}
                    taskResource={ui?.globalDialogs?.createTaskDialog?.data?.taskResource}
                    globalDialog={ui?.globalDialogs?.createTaskDialog?.data?.globalDialog}
                    taskName={ui?.globalDialogs?.createTaskDialog?.data?.TaskName}
                    taskDescription={ui?.globalDialogs?.createTaskDialog?.data?.Description}
                    pathname={location.pathname}
                    translate={translate}
                />
            </Modal>

            <ContactGroupCardDialog
                show={!!ui?.globalDialogs?.ViewContactGroupCard?.visible}
                onClose={() => dispatch(hideGlobalModal("ViewContactGroupCard"))}
                translate={translate}
                data={ui?.globalDialogs?.ViewContactGroupCard?.data}
            />

            {ui.mapDialog && (
                <MapDialog
                    ui={ui}
                    translate={translate}
                />
            )}

            <Modal
                show={ui.modalName === 'ViewOfficeCard'}
                widthClass={"max-w-3xl"}
                translate={translate}
                onClose={() => dispatch(hideModal("ViewOfficeCard", 0))}
            >
                <ModalHeader
                    title={translate("text.office_info")}
                    onClose={() => dispatch(hideModal("ViewOfficeCard", 0))}
                />

                <OfficeCardDialog
                    onClose={() => dispatch(hideModal("ViewOfficeCard", 0))}
                    translate={translate}
                    office={ui.data}
                />
            </Modal>

            <Modal
                show={ui.modalName === 'ViewLocationCard'}
                widthClass={"max-w-3xl"}
                onClose={() => dispatch(hideModal("ViewLocationCard", 0))}
            >
                <ModalHeader
                    title={translate("text.location_info")}
                    onClose={() => dispatch(hideModal("ViewLocationCard", 0))}
                />

                <LocationCardDialog
                    translate={translate}
                    item={ui.data}
                    dispatch={dispatch}
                    onClose={() => dispatch(hideModal("ViewLocationCard", 0))}
                />
            </Modal>

            {ui?.globalDialogs?.ChangePassword?.visible &&
                <ChangePasswordDialog
                    translate={translate}
                />
            }

            <ModalDefault
                show={ui?.globalDialogs?.About?.visible}
                widthClass={"max-w-xl"}
                translate={translate}
                title={translate("modal_heading.About")}
                onClose={() => dispatch(hideGlobalModal('About', 0))}
                closeButtonLabel={translate("btn.close")}
            >
                <About translate={translate}/>
            </ModalDefault>

            <ModalSupport
                title={ui?.globalDialogs?.ticketingModal?.data?.title}
                show={!!ui?.globalDialogs?.ticketingModal?.visible}
                history={history}
                dispatch={dispatch}
                translate={translate}
            />

            <Modal
                show={!!ui?.globalDialogs?.GrabbedTask?.visible}
                widthClass={"max-w-3xl"}
            >
                <ModalHeader
                    onClose={() => {
                        dispatch(hideGlobalModal('GrabbedTask', 0));
                        dispatch(getGrabTaskResource({
                            user: LocalStorage.get("user"),
                            resource: Resources.DashboardTasks,
                            request: 'GET'
                        }))
                    }}
                    title={ui?.globalDialogs?.GrabbedTask?.data?.task?.TaskID ? translate("modal_heading.grabbedTask") : translate("modal_heading.no_task")}
                />
                <TaskGrabDialog
                    onClose={() => {
                        dispatch(hideGlobalModal('GrabbedTask', 0));
                        dispatch(getGrabTaskResource({
                            user: LocalStorage.get("user"),
                            resource: Resources.DashboardTasks,
                            request: 'GET'
                        }))
                    }}
                    translate={translate}
                    dispatch={dispatch}
                    item={ui?.globalDialogs?.GrabbedTask?.data}
                />
            </Modal>


            <KnowledgeBase
                onClose={() => dispatch(hideGlobalModal("knowledgeBaseSlideOver"))}
                open={!!ui?.globalDialogs?.knowledgeBaseSlideOver?.visible}
                translate={translate}
                dispatch={dispatch}
                helpResource={helpResource}
                history={history}
            />
        </>
    )
}